import { createApp } from 'vue'
import App from './App.vue'
import router from '@/router/index'
import VueI18n from '@/lang'
//  引入vant样式
import 'vant/lib/index.css';
//  引入自定义样式
import './assets/main.css'

const app = createApp(App)
app.use(router)
app.use(VueI18n)
app.mount('#app')
